<template>
  <div class="pagination align-center">
    <el-pagination
      v-bind="$attrs"
      :current-page.sync="params.page"
      :page-size.sync="params.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      layout="total, sizes, prev, pager, next"
      v-on="$listeners"
    />
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss">
.pagination {
  padding: $padding-lg;
}
</style>
